import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[900],
  color: theme.palette.common.fogWhite,
  position: 'relative',
  '& .MPSContainer': {
    maxWidth: `${theme.spacing(160)} !important`,
    position: 'relative',
    zIndex: 1,
  },
  '& .MPSWrapper': {
    padding: theme.spacing(14, 0),
    gap: theme.spacing(10),
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(8, 0),
      gap: theme.spacing(8),
    },
  },
  '&::after': {
    [theme.breakpoints.up('md')]: {
      backgroundImage: "url('/imgs/Rebranding/HomePage/Asphalt.png')",
      backgroundAttachment: 'fixed',
      backgroundSize: 'cover',
      bottom: 0,
      top: 0,
      height: '100%',
      content: '""',
      width: '100%',
      position: 'absolute',
      right: 0,
      left: 0,
    },
  },
  '& .MPSAction': {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
    '&:hover, &:focus': {
      backgroundColor: theme.palette.common.fogWhite,
      color: theme.palette.common.black,
    },
  },
}));

export default StyledBox;